import { createContext } from 'react'

const klaviyoContext = createContext()

export default klaviyoContext
